const playlistMapping = {
  solo: 'p2',
  duo: 'p10',
  squad: 'p9',
};

export function mapPlaylist(friendlyName) {
  return playlistMapping[friendlyName];
}

export function mapFriendly(playlistName) {
  for (const name in playlistMapping) {
    if (!Object.prototype.hasOwnProperty.call(playlistMapping, name)) continue;
    if (playlistMapping[name] === playlistName) return name;
  }
  return null;
}
